import { CLICKED, CMSPath, DONT_CLEAR_INAPPBROWSER_CACHE, EXIT, HIDE_INAPPBROWSER_NAVIGATION, LOAD_ERROR } from '../../config/constant';
import { TheKnowResponseCodeFromHostedScriptForInAppBrowser } from '../components/theKnow';
import { calculateTimeDifference, getDefaultAnalyticsLabel, renderPDFFile, toBool } from './utility';

const getFileName = (url) => {
    let len = url.split("/").length
    return url.split("/")[len-1]
}

export const inAppBrowser = (
                targetUrl,
                {
                    menuColor,
                    installedAppBuildNo,
                    installedAppVersion,
                    guestDetail,
                    sendAnalytics,
                    guestIsLoggedIn,
                    currentWidget,
                    currentHomePage,
                    setLoader,
                    setFailScreen,
                    setOpenExternalLinkInSameTab,
                    setExternalSignIn,
                    setGoHome
                }, 
                hideNavButton, widget, hideBrowserSession) => {

    // Send Analytics
    let widgetLaunchTime = new Date
    let label = getDefaultAnalyticsLabel({appVersion: installedAppVersion ? `${installedAppVersion}(${installedAppBuildNo})`: ""})
    sendAnalytics(
        guestDetail, 
        widget.displayName, 
        CLICKED, 
        {...label, "layoutTab": currentHomePage && currentHomePage.tabName},
        0, 
        guestIsLoggedIn
    );
    //

    // if (!navigator.onLine) {
    //     setFailScreen(
    //         true,
    //         "No Internet Connection",
    //         "It looks like you're offline. Please check your connection and try again.",
    //         true
    //     );
    //     return;
    // }

    if(targetUrl=="##"){
        return;
    }

    let inAppBrowserRef;
    let targetUrlrenderer;

    if(`${targetUrl}`.startsWith('http://') || `${targetUrl}`.startsWith('https://')){
            console.log('${CMSPath}${targetUrl}',`${CMSPath}${targetUrl}`)
            targetUrlrenderer = `${targetUrl}`;
        } else{
            targetUrlrenderer = `${CMSPath}${targetUrl}`;
            console.log('${targetUrlrenderer}',`${targetUrlrenderer}`)
        }

    console.log("Inappbrowser path",`${targetUrlrenderer}`)
 
    let brandLogo = sessionStorage.getItem("brandLogo") ? CMSPath + sessionStorage.getItem("brandLogo").replace("../", "") : "";
    
    if (window.cordova || window.device) {
        if (window.device.platform === "Android") {

            let isPDF = `${targetUrlrenderer}`.endsWith(".pdf")
            

            console.log("isPDF", isPDF);
            let pdfFileName = isPDF ? getFileName(targetUrlrenderer) : ""

            if(isPDF){
                let url = targetUrlrenderer
                if(url.toLowerCase().startsWith("https")) {
                    url = url.replace("https", "http")
                    url = url.replace("8443", "8080")
                }

                setLoader(true, "Downloading file ..... Please wait", true)
                renderPDFFile(url, pdfFileName, setLoader, setFailScreen)
            } else {
                inAppBrowserRef = window.cordova.InAppBrowser.open(
                    `${targetUrlrenderer}`,
                    (widget.meta && widget.meta.loadInExternalBrowser) ? toBool(widget.meta.loadInExternalBrowser) ? '_system' : '_blank' : '_blank',
                    `location=yes,hideurlbar=yes,hidden=${hideBrowserSession ? "yes" : "no"},clearcache=no,brandLogo=${brandLogo},closebuttoncaption=backchevron,closebuttoncolor=${menuColor.assetFontSelectorColor},toolbarcolor=${menuColor.selectorColor},lefttoright=yes,hidenavigationbuttons=${HIDE_INAPPBROWSER_NAVIGATION ? "yes" : hideNavButton ? 'yes' : 'no'}`
                );
            }


        } else {
            
            // inAppBrowserRef = window.cordova.InAppBrowser.open(
            //     `${targetUrlrenderer}`,
            //     (widget.meta && widget.meta.loadInExternalBrowser) ? toBool(widget.meta.loadInExternalBrowser) ? '_system' : '_blank' : '_blank',
            //     `location=no,clearcache=${DONT_CLEAR_INAPPBROWSER_CACHE ? "no" : "yes"},closebuttoncaption=Close,closebuttoncolor=${menuColor.assetFontColor},toolbar=yes,toolbarposition=top,toolbarcolor=${menuColor.backgroundColor},hidenavigationbuttons=${hideNavButton ? 'yes' : 'no'}`
            // );

            inAppBrowserRef = window.cordova.InAppBrowser.open(
                `${targetUrlrenderer}`,
                (widget.meta && widget.meta.loadInExternalBrowser) ? toBool(widget.meta.loadInExternalBrowser) ? '_system' : '_blank' : '_blank',
                `location=no,presentationstyle=fullscreen,mediaPlaybackRequiresUserAction=yes,hidden=${hideBrowserSession ? "yes" : "no"},clearcache=no,brandLogo=${brandLogo},closebuttoncaption=backchevron,closebuttoncolor=${menuColor.assetFontSelectorColor},toolbar=yes,toolbarposition=top,toolbarcolor=${menuColor.selectorColor},toolbartranslucent=no,hidenavigationbuttons=${HIDE_INAPPBROWSER_NAVIGATION ? "yes" : hideNavButton ? 'yes' : 'no'}`
            );
        }
    } else {
            console.log('widget-',widget);

            if(process.env.REACT_APP_EMBED_WEB_URL_IFRAME == "true"){
                if(widget.meta && widget.meta.loadInExternalBrowser){
                    window.open(`${targetUrlrenderer}`)
                } else if(widget && widget.targetUrl){
                    currentWidget(widget);
                    setOpenExternalLinkInSameTab(true);
                } else{
                    window.open(`${targetUrlrenderer}`)
                }
            } else {
                window.open(`${targetUrlrenderer}`)
            }
            
        }

    if(inAppBrowserRef){

        inAppBrowserRef.addEventListener("loadstart", (params) => {

        })
    

        inAppBrowserRef.addEventListener('loaderror', (params) => {

            if(params && params.code === -2){
                inAppBrowserRef.close();

                let widgetCloseTime = new Date
                let duration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');

                sendAnalytics(
                    guestDetail, 
                    widget.displayName, 
                    LOAD_ERROR, 
                    {...label, "layoutTab": currentHomePage && currentHomePage.tabName}, 
                    duration, 
                    guestIsLoggedIn
                );
            }
        });
        
        inAppBrowserRef.addEventListener('exit', (params) => {
                console.log("params exit", params, JSON.stringify(params))
                let widgetCloseTime = new Date
                let duration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');

                sendAnalytics(
                    guestDetail, 
                    widget.displayName, 
                    EXIT, 
                    {...label, "layoutTab": currentHomePage && currentHomePage.tabName, "duration": duration}, 
                    0, 
                    guestIsLoggedIn
                );
                
                if(widget.isTheKnowSsoLink && widget.checkWhetherGotMemberId) widget.checkWhetherGotMemberId();
                if(widget.isTheKnowModifyReservationLink && widget.modifyIabBackCalled) widget.modifyIabBackCalled();

                if(!widget.dontSetCurrentWidget){
                    currentWidget({})
                    setGoHome && setGoHome(true);
                }
        });


        inAppBrowserRef.addEventListener('message',(msg)=>{

            console.log("inappbrowser msg received",msg);

            const receivedMsg = msg;
            console.log("receivedMsg",receivedMsg);

            if(TheKnowResponseCodeFromHostedScriptForInAppBrowser.REDIRECTION_URI==receivedMsg.data.responseCode){
            }
           else if(TheKnowResponseCodeFromHostedScriptForInAppBrowser.hasOwnProperty(receivedMsg.data.responseCode)){
                console.log("inside ")
                if(receivedMsg.data && receivedMsg.data.data && receivedMsg.data.data.additionalData){
                    for(let [key, value] of Object.entries(receivedMsg.data.data.additionalData)){
                        setExternalSignIn(key,value);
                    }
                }
                setExternalSignIn("responseReceivedFromHostedScript",receivedMsg.data.responseCode)                

                if(receivedMsg.data.responseCode == TheKnowResponseCodeFromHostedScriptForInAppBrowser.GOT_MEMBER_ID) {
                    localStorage.setItem("theKnowUserInfo", JSON.stringify({ memberId: receivedMsg.data.data.additionalData.memberId, jwtIdToken: receivedMsg.data.data.additionalData.jwtIdToken , dateCreated: new Date()}))    
                }      
                if(receivedMsg.data.responseCode!=TheKnowResponseCodeFromHostedScriptForInAppBrowser.GOT_MEMBER_ID) {                 
                    inAppBrowserRef.close();
                }
            }
        })
    }
}

